var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"view":"secondary","icon":'icon-shareAlt_outline'},on:{"click":_vm.share}},[_vm._v("Отправить")])
}
var staticRenderFns = []

export { render, staticRenderFns }